import React from 'react'

const ReviewsContainer = () => {
  return (
    <div>
      {/* <div data-trustmary-widget="JlSDoe2O7"></div> */}
      {/* {<script src="https://widget.trustmary.com/JlSDoe2O7"></script>} */}
    </div>
  )
}

export default ReviewsContainer
